import alert from './alert'
import constant from './constant'
import date from './date'
import loading from './loading'
import telefone from './telefone'
import socket from './socket'
import fileManagerUtils from './fileManagerUtils'
import parametros from './parametros'

export default {
    install(Vue) {
        Vue.mixin(alert)
        Vue.mixin(constant)
        Vue.mixin(date)
        Vue.mixin(loading)
        Vue.mixin(telefone)
        Vue.mixin(socket)
        Vue.mixin(fileManagerUtils)
        Vue.mixin(parametros)
    }
}